<template>
  <div class="col">
    <b-form-group
      :label="labelName"
      label-cols="4"
      label-cols-sm="3"
      label-cols-md="auto"
      label-class="text-secondary"
    >
      <div class="form-row radio-row">
        <b-form-radio
          v-model="val"
          name="radio-sub-component"
          ref="radio"
          v-for="(item, index) in radioData"
          :key="index"
          :value="item.csiValue"
          @change="changeInput(item)"
        >
          {{ item.csiName }}</b-form-radio
        >
      </div>
    </b-form-group>
  </div>
</template>
<script>
export default {
  name: 'InputRadio',

  props: {
    labelName: {
      type: String,
      default: '',
    },
    radioData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      val: 'year', // 選中選項
      today: this.$moment().local().format('yyyy-MM-DD 23:59:59.000'),
      receiptStart: null,
      receiptEnd: null,
    };
  },
  created() {
    // this.receiptEnd = this.today;
    // this.$emit('getDate', this.receiptStart, this.receiptEnd);
  },
  methods: {
    changeInput(item) {
      this.receiptEnd = this.today;
      if (item.csiValue === 'month') {
        this.receiptStart = this.startDate(1, 'months');
      } else if (item.csiValue === 'season') {
        this.receiptStart = this.startDate(3, 'months');
      } else if (item.csiValue === 'halfYear') {
        this.receiptStart = this.startDate(6, 'months');
      } else if (item.csiValue === 'year') {
        this.receiptStart = this.startDate(1, 'years');
      }
      this.$emit('getDate', this.receiptStart, this.receiptEnd);
    },
    startDate(num, type) {
      return this.$moment().local().subtract(num, type).format('yyyy-MM-DD 00:00:00.000');
    },
  },
};
</script>
